var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',{staticClass:"footer"},[_c('el-col',{staticClass:"footer-container"},[_c('el-col',{staticClass:"copyright item"},[_vm._v("版权所有@深圳市伊登软件有限公司 2020 保留一切权利")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }